export const codeRegex = /^[a-zA-Z0-9-_]+$/;
export const cannotStartWithNumberRegex = /^[a-zA-Z]{1}/;
export const alphabetsNumbersRegex = /^[a-zA-Z0-9 ]+$/;
export const whiteSpaceRegEx = /^[^\s].*/;
export const allowedCharacters = /^[a-zA-Z0-9()\-_]+$/;
export const whiteSpaceAndSpecial = /^[a-zA-Z0-9\_]+$/;
export const regExpOnlyNumber = /^[0-9]+$/;
export const nameRegexAllow = /^[a-zA-Z0-9.,\-_' ]+$/;
